export default __webpack_public_path__ + "static/media/UnderConsruction.60149ae0.jpg";